<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item @click.native="gohome"><a>首页</a></el-breadcrumb-item>
      <el-breadcrumb-item>补充工伤保险补缴办理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区 步骤一 -->
    <el-card id="card_st" v-show="cardshow">
      <div slot="header" class="clearfix">
        <span style="font-size: 24px;font-weight: 500;">补充工伤保险补缴办理</span>
      </div>
      <div style="padding-top: 10px;text-align: center;">
        <span style="color: red;">{{ messages }}</span>
      </div>
    </el-card>
    <!-- 卡片视图区 步骤一 -->
    <el-card id="card_st" v-show="steponeShow">
      <div slot="header" class="clearfix">
        <span style="font-size: 24px;font-weight: 500;">补充工伤保险补缴办理</span>
      </div>
      <el-steps :active="1">
        <el-step title="填写基本信息" icon="el-icon-edit"></el-step>
        <el-step title="上传人员信息" icon="el-icon-upload"></el-step>
        <el-step title="完成" icon="el-icon-picture"></el-step>
      </el-steps>
      <el-alert title="提示：补充工伤提交人员名单要与当月工伤保险人员名单一致，非本单位职工不予报销。" type="error" style="margin-bottom: 10px;"></el-alert>
      <div class="text item" style="padding-top: 30px;">
        单位编号：{{ user.aab001 }}
      </div>
      <div class="text item">
        单位名称：{{ user.aab002 }}
      </div>
      <div class="text item">
        补缴时间段：
        <el-date-picker
            v-model="startTime"
            @change="getdateValue"
            type="monthrange"
            format="yyyy-MM"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
        </el-date-picker>
        <span style="margin-left: 30px;">生效时期：{{ piccnew.timeaction }}到{{ piccnew.timeend }}</span>
      </div>
      <div class="text item">
        补缴标准：{{ user.column2 }}元/人/月
      </div>
      <div class="text item">
        参保人数：
<!--        <el-input style="width: 200px;" oninput="if(value < 0 ){value = ''}" onkeyup="value=value.replace(/[^\d]/g,'');"-->
<!--                  @input="getspacee(piccnew.num)" v-model="piccnew.num" placeholder="请输入人数"></el-input>-->
        <el-input-number v-model="piccnew.num" @change="getspacee(piccnew.num)" :min="0"  label="参保人数"></el-input-number>
      </div>
      <div class="text item">
        应缴钱数：
        <el-input style="width: 200px;" placeholder="应缴钱数" v-model="piccnew.spacec" :disabled="true"></el-input>
      </div>
      <!--    <span style="color: red;">1：在当月已经办理业务并生效、无人员变动的情况下可以选择时间段进行补缴过往的月份。</span> <br><br>-->
      <!--    <span style="color: red;">2：补缴月份不享受工亡待遇。</span>-->
      <div style=" text-align: center;">
        <el-button type="primary" @click="stepOne">确认申请参保</el-button>
        <!--      <el-button type="primary" style="width: 200px;margin-top: 20px;" @click="insertfile">确认申请参保</el-button>-->
      </div>


    </el-card>
    <!-- 卡片视图区 步骤一 -->
    <el-card id="card_st" v-show="yjblShow">

      <el-alert title="提示：补充工伤提交人员名单要与当月工伤保险人员名单一致，非本单位职工不予报销。" type="error" style="margin-bottom: 10px;"></el-alert>
      <div style="padding-top: 10px;text-align: center;">
        <span style="color: red;">已申请!请点击受理记录查看</span>

      </div>

    </el-card>
    <el-card id="card_st" v-show="steptwoShow">
      <el-steps :active="2">
        <el-step title="填写基本信息" icon="el-icon-edit"></el-step>
        <el-step title="上传人员名单" icon="el-icon-upload"></el-step>
        <el-step title="完成" icon="el-icon-picture"></el-step>
      </el-steps>
      <el-alert title="提示：补充工伤提交人员名单要与当月工伤保险人员名单一致，非本单位职工不予报销。" type="error" style="margin-bottom: 10px;"></el-alert>
      <input ref="file" type="file" accept=".xlsx,.xls" style="display: none;" @change="uploadFile">
      <el-button type="primary" icon="el-icon-upload" @click="clickFile">上传人员名单</el-button>
      <el-button class="rymdmb" type="success1" @click="downloadMb">下载人员名单模板</el-button>
      <el-button type="warning" @click="uploadHelp = true">上传文件帮助</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteFile(user.aab001)" v-if="deleteshow">清空人员名单
      </el-button>
      <el-button type="success" icon="el-icon-top" @click="txjbxx">返回上级</el-button>


      <el-alert :title="alert_1" type="info" :closable="false" center show-icon></el-alert>
      <!-- 用户列表 -->
      <el-table :data="redisPagelist" border stripe value-format="timestamp" :header-cell-style="thStyleFun"
                :cell-style="cellStyleFun">
        <el-table-column label="序号" prop="" width="180" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="aac003"></el-table-column>
        <el-table-column label="身份证号" prop="aac002"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" size="mini"
                       @click="deleteRedisPageList(scope.row.spaced)"></el-button>

          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="queryInfo.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-alert :title="alert_success" v-show="showfilelist" :closable="false" center type="success" show-icon>
      </el-alert>
      <el-alert :title="alert_error" v-show="showfilelist" :closable="false" center type="error" show-icon>
      </el-alert>
      <!-- 上传失败列表 -->

      <el-table :data="errorlist" v-show="showfilelist" border stripe value-format="timestamp"
                :header-cell-style="thStyleFun" :cell-style="cellStyleFun">
        <el-table-column label="序号" prop="" width="180" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="aac003"></el-table-column>
        <el-table-column label="身份证号" prop="aac002"></el-table-column>
      </el-table>
      <div style="text-align: center;">
        <el-button type="primary" style="width: 200px;margin-top: 20px;" @click="insertfile">确定</el-button>
      </div>

    </el-card>
    <el-dialog title="单位信息维护" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
               :visible.sync="dialogFormVisible">
      <el-form :model="updateuser" ref="updateuser" label-width="110px" :rules="updateuserRules" class="demo-ruleForm"
               style="text-align: center;">
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="单位编号" prop="aab001">
              <el-col :span="24">
                <el-input v-model="updateuser.aab001" :disabled="true" placeholder="请输入单位编号"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="单位名称" prop="aab002">
              <el-col :span="24">
                <el-input v-model="updateuser.aab002" placeholder="请输入单位名称"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="单位地址" prop="address">
              <el-col :span="24">
                <el-input v-model="updateuser.address" placeholder="请输入单位地址"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="联系人姓名" prop="lxrname">
              <el-col :span="24">
                <el-input v-model="updateuser.lxrname" placeholder="请输入联系人姓名"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="联系人电话" prop="lxrphone">
              <el-col :span="24">
                <el-input v-model="updateuser.lxrphone" placeholder="请输入联系人电话"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="邮箱" prop="lxremail">
              <el-col :span="24">
                <el-input v-model="updateuser.lxremail" placeholder="请输入邮箱"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-row :gutter="20">-->
        <!--            <el-col :span="18" :offset="2">-->
        <!--                <el-form-item label="行业类型">-->
        <!--                    <el-col :span="6" style="text-align: left;">-->
        <!--                        <el-button :type="buttontype" @click="innerVisible = true">{{buttonstate}}</el-button>-->

        <!--                    </el-col>-->
        <!--                    <el-col :span="18" style="text-align: left;" prop="column1">-->
        <!--                        <span>{{updateuser.column1}}</span>-->
        <!--                    </el-col>-->
        <!--                </el-form-item>-->
        <!--            </el-col>-->
        <!--        </el-row>-->
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="统一信用代码" prop="snumber">
              <el-col :span="24">
                <el-input v-model="updateuser.snumber" placeholder="请输入统一信用代码"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="法人代表" prop="headuser">
              <el-col :span="24">
                <el-input v-model="updateuser.headuser" placeholder="请输入法人代表"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="注册所在区" prop="dsfj">
              <el-col :span="24" style="text-align: left;">
                <el-select v-model="updateuser.dsfj" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>

            </el-form-item>
          </el-col>
        </el-row>


      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="submitForm('updateuser')">确定修改</el-button>
        <!-- <el-button @click="resetForm('updateuser')">重置</el-button> -->
      </div>
      <el-dialog width="50%" title="请选择行业类型" :visible.sync="innerVisible" append-to-body>
        <el-table ref="multipleTable" :data="tableData" :show-overflow-tooltip='true' tooltip-effect="dark"
                  style="width: 100%">
          <el-table-column width="60">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="usertype"
                        @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="hylb" width="80" label="行业类别">
          </el-table-column>
          <el-table-column prop="fy" label="补缴标准" width="140">
          </el-table-column>
          <el-table-column prop="ejfl" label="二级分类" width="80">
          </el-table-column>
          <el-table-column prop="hymc" label="行业名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="baserate" label="基准费率(%)" width="90">
          </el-table-column>

        </el-table>
        <div style="padding-top: 10px;text-align: center;">
          <el-button type="primary" @click="gethylb">确定</el-button>
        </div>
      </el-dialog>

    </el-dialog>

  </div>


</template>
<script>
import Vue from 'vue'
import moment from "moment";
export default {
  inject: ['reload'],
  data() {
    let moment = require('moment');
    return {
      user: '',
      // 请求数据
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < moment().startOf('year')  || time.getTime() > moment().endOf('year');
        }
      },
      piccnew: {
        aab001: '',
        term: '2',
        timeaction: '',
        timeend: '',
        num: '',
        userstatus: '0',
        spacea: '',
        spaceb: '',
        spacec: '',
        spaced: '',
        spacee: '',
        spacef: '1',
        spaceg: '0',
      },
      //单位信息维护
      dialogFormVisible: false,
      innerVisible: false,

      //补缴过往月份时间
      startTime: '',
      endTime: '',

      //补缴月数
      monthnum: 0,

      messages: '',
      cardshow: false,

      updateuser: {
        aab001: '',
        aab002: '',
        address: '',
        lxrname: '',
        lxrphone: '',
        lxremail: '',
        snumber: '',
        headuser: '',
        dsfj: '',
        usertype: '',
        column1: '',
        rqtime: ''


      },

      //清空人员名单button展示
      deleteshow: false,

      tableData: [{
        hylb: '一类甲',
        fy: '6元',
        ejfl: '一类甲',
        hymc: '软件和信息技术服务业，货币金融服务，资本市场服务， 保险业， 其他金融业， 科技推广和应用服务业， 社会工作， 广播、 电视、 电影和影视录音制作业， 中国共产党机关， 国家机构， 人民政协、 民主党派， 社会保障， 群众团体、 社会团体和其他成员组织， 基层群众自治组织， 国际组织。 ',
        baserate: '0.3'
      }, {
        hylb: '一类乙',
        fy: '12元',
        ejfl: '一类乙',
        hymc: '批发业，零售业，仓储业，邮政业，住宿业，餐饮业，电信、广播电视和卫星传输服务，互联网和相关服务，房地产业，租赁业，商务服务业，研究和试验发展，专业技术服务业，居民服务业，其他服务业，教育，卫生，新闻和出版业，文化艺术业。',
        baserate: '0.6'
      }, {
        hylb: '二类甲',
        fy: '9元',
        ejfl: '二类甲',
        hymc: '农副食品加工业，食品制造业，酒、饮料和精制茶制造业，烟草制品业，纺织业，木材加工和木、竹、藤、棕、草制品业，文教、工美、体育和娱乐用品制造业，计算机、通信和其他电子设备制造业，仪农副食品加工业，食品制造业，酒、饮料和精制茶制造业，烟草制品业，纺织业，木材加工和木、竹、藤、棕、草制品业，文教、工美、体育和娱乐用品制造业，计算机、通信和其他电子设备制造业，仪器仪表制造业，其他制造业，水的生产和供应业，机动车、电子产品和日用产品修理业，水利管理业，生态保护和环境治理业，公共设施管理业，娱乐业。',
        baserate: '1.05'
      }, {
        hylb: '二类乙',
        fy: '9元',
        ejfl: '二类乙',
        hymc: '农业，畜牧业，农、林、牧、渔服务业，纺织服装、服饰业，皮革、毛皮、羽毛及其制品和制鞋业，印刷和记录媒介复制业，医药制造业，化学纤维制造业，橡胶和塑料制品业，金属制品业，通用设备制造业，专用设备制造业，汽车制造业，铁路、船舶、航空航天和其他运输设备制造业，电气机械和器材制造业，废弃资源综合利用业，金属制品、机械和设备修理业，电力、热力生产和供应业，燃气生产和供应业，铁路运输业，航空运输业，管道运输业，体育。',
        baserate: '1.35'
      }, {
        hylb: '二类丙',
        fy: '9元',
        ejfl: '二类丙',
        hymc: '林业，开采辅助活动，家具制造业，造纸和纸制品业，建筑安装业，建筑装饰和其他建筑业，道路运输业，水上运输业，装卸搬运和运输代理业。',
        baserate: '1.65',
      }, {
        hylb: '三类甲',
        fy: '11元',
        ejfl: '三类甲',
        hymc: '渔业，化学原料和化学制品制造业，非金属矿物制品业，黑色金属冶炼和压延加工业，有色金属冶炼和压延加工业，房屋建筑业，土木工程建筑业。',
        baserate: '1.95'
      }, {
        hylb: '三类乙',
        fy: '11元',
        ejfl: '三类乙',
        hymc: '石油和天然气开采业，其他采矿业，石油加工、炼焦和核燃料加工业。',
        baserate: '2.4'
      }, {
        hylb: '三类丙',
        fy: '11元',
        ejfl: '三类丙',
        hymc: '煤炭开采和洗选业，黑色金属矿采选业，有色金矿采选业，非金属矿采选业。',
        baserate: '2.85'

      }],
      //选择行业类别
      usertype: '',
      //选择注册所在区
      options:  [{
        value:   '01',
        label:   '盘锦市本级'
      },   {
        value:   '02',
        label:   '兴隆台区'
      },   {
        value:   '03',
        label:   '辽东湾'
      },   {
        value:   '04',
        label:   '双台子区'
      },   {
        value:   '05',
        label:   '大洼县'
      },   {
        value:   '06',
        label:   '盘山县'
      },   {
        value:   '07',
        label:   '油田'
      },   {
        value:   '08',
        label:   '事业单位'
      }],

      updateuserRules: {
        aab001: [{
          required: true,
          message: '请输入单位编号',
          trigger: 'blur'
        }, {
          min: 20,
          max: 20,
          message: '长度 20 个字符',
          trigger: 'blur'
        }],
        aab002: [{
          required: true,
          message: '请单位名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请单位地址',
          trigger: 'blur'
        }],
        lxrname: [{
          required: true,
          message: '请联系人姓名',
          trigger: 'blur'
        }],
        lxrphone: [{
          message: '请输入手机号',
          required: true,
          trigger: 'blur'
        }],
        lxremail: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change']
        }],
        column1: [{
          required: true,
          message: '请选择行业类型',
          trigger: 'change'
        }],
        snumber: [{
          required: true,
          message: '请输入统一信用代码',
          trigger: 'blur'
        }],
        headuser: [{
          required: true,
          message: '请输入法人代表',
          trigger: 'blur'
        }],
        dsfj: [{

          required: true,
          message: '请选择注册所在区',
          trigger: 'change'
        }],

      },
      total: 0,
      //参保步骤展示
      steponeShow: false,
      steptwoShow: false,
      yjblShow: false,

      //展示上传人数成功信息
      showfilelist: false,

      redisPagelist: [], // 用户列表
      errorlist: [], //上传错误列表
      alert_1: '您选择：月缴，参保人数为：人',
      alert_success: '',
      alert_error: '',

      thStyleFun() {
        return 'text-align:center'
      },
      cellStyleFun() {
        return 'text-align:center'
      }

    }

  },
  created() {
    // const piccuser = JSON.parse(window.sessionStorage.getItem("user")); // session取值

    console.log(JSON.parse(window.sessionStorage.getItem("user")));
    this.user = JSON.parse(window.sessionStorage.getItem("user"));
    window.addEventListener('setItem', () => {

      this.user = JSON.parse(window.sessionStorage.getItem("user"));

    })
    this.updateuser = this.user;

    const date = new Date()
    const y = date.getFullYear()
    const m = date.getMonth()
    let fristDay = new Date(y, m, 1)
    let lastDay = new Date(y, m+1,0)
// fristDay = formatDateByJSON(fristDay.getTime())
    let a = fristDay.getTime()
    let b = lastDay.getTime()
    if (!a) a = new Date().getTime()
    else a = new Date(a).getTime()
    const date1 = new Date(a + 8 * 3600 * 1000)
    fristDay =  date1.toJSON().substr(0, 19).replace('T', ' ').split(' ')[0]
    if (!b) b = new Date().getTime()
    else b = new Date(b).getTime()
    const date2 = new Date(b + 8 * 3600 * 1000)
    lastDay =  date2.toJSON().substr(0, 19).replace('T', ' ').split(' ')[0]
    // start.setMonth(start.getMonth() - 6);
    this.startTime = [date1, date2];
    this.piccnew.timeaction =fristDay;// moment(this.startTime[0]).startOf('month').format("YYYY-MM-DD");
    this.piccnew.timeend = lastDay ;//moment(this.startTime[1]).endOf('month').format("YYYY-MM-DD");

    let date11 = this.piccnew.timeend.split('-'); //例：将2020-12-21 的-去掉
    date11 = parseInt(date11[0]) * 12 + parseInt(date11[1]); //将字符串转换为数字格式
    let date22 = this.piccnew.timeaction.split('-');
    date22 = parseInt(date22[0]) * 12 + parseInt(date22[1]);
    this.monthnum = date11 - date22 +1;

    // if (this.updateuser.usertype != null) {
    //     this.usertype = (this.updateuser.usertype.substring(1) - 0) - 1;
    // } else {
    //     this.$message({
    //         message: "请单位信息维护",
    //         type: 'warning'
    //     });
    //     this.dialogFormVisible = true;
    // }
    if (this.updateuser.address != null) {
      // this.usertype = (this.updateuser.usertype.substring(1) - 0) - 1;
    } else {
      this.$message({
        showClose: true,
        message: "请单位信息维护",
        type: 'warning',
        customClass: 'mzindex'
      });
      this.dialogFormVisible = true;
    }
    this.dqsfbl();
    // this.aab001 = piccuser.aab001;
    // console.log(window.sessionStorage.getItem("user"))
    //js引入
    this.piccnew.aab001 = this.user.aab001;
    this.piccnew.spaced = this.user.lxrname;
    this.piccnew.spacee = this.user.lxrphone;
    // let moment = require('moment');
    // this.piccnew.timeaction = moment().startOf('month').subtract('month', -1).format("YYYY-MM-DD"); //下个月初
    // this.piccnew.timeend = moment().endOf('month').subtract('month', -1).endOf('month').format("YYYY-MM-DD") //下个月末




  },

  methods: {
    stepOne() {

      if (this.piccnew.num == "") {
        this.$message({
          duration: 600,
          type: 'error',
          message: '请输入参保人数！！！'
        });
        return;
      } else if (this.startTime == "") {
        this.$message({
          duration: 600,
          type: 'error',
          message: '请选择补缴时间段！！！'
        });
        return;
      }else {
        this.steponeShow = !this.steponeShow;
        this.steptwoShow = !this.steptwoShow;
        this.alert_1 = '补充工伤(补缴)，参保人数为：' + this.piccnew.num + '人，补缴时间段：'+this.piccnew.timeaction +'到'+ this.piccnew.timeend ;
      }

    },
    clickFile() {
      this.$refs.file.dispatchEvent(new MouseEvent('click'))
    },
    handleExcelSuccess(res, file) {
      console.log(res, file);

      if (res.msg === "ok") {
        this.$message("上传成功");
        this.getList();
      }
    },
    //redis中获取上传人员名单
    async redisPageList() {
      // 在$.post()前把ajax设置为同步：$.ajaxSettings.async = false;
      // 在$.post()后把ajax改回为异步：$.ajaxSettings.async = true;
      var formData = new FormData()
      formData.append('pageNum', this.queryInfo.pageNum);
      formData.append('pageSize', this.queryInfo.pageSize);
      formData.append('aab001', "2_"+this.piccnew.aab001);
      // 调用post请求
      const {

        data: res
      } = await this.$http.post("redisPage", formData, {
        // pageNum: this.queryInfo.pageNum,
        // pageSize: this.queryInfo.pageSize,
        // aab001: this.piccnew.aab001

      }, {


      });
      this.redisPagelist = res.data; // 将返回数据赋值
      this.total = res.numbers; // 总个数

    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.redisPageList(); // 数据发生改变重新申请数据
    },
    // 监听pageNum改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.redisPageList(); // 数据发生改变重新申请数据
    },
    // 导入数据
    uploadFile() {
      const file = this.$refs.file.files
      var extName = file[0].name.substring(file[0].name.lastIndexOf('.')).toLowerCase()
      // var username = this.$store.getters.name
      if (extName === '.xlsx' || extName === '.xls') {
        var formData = new FormData()
        formData.append('file', file[0]);
        formData.append('spacea', this.piccnew.spacea);
        formData.append('aab001', this.piccnew.aab001);
        formData.append('spacec', this.user.aab002);
        formData.append('spaceb', this.user.dsfj);
        formData.append('num', this.piccnew.num);
        formData.append('term', this.piccnew.term);
        formData.append('timeaction',new Date(this.piccnew.timeaction))
        formData.append('timeend',new Date(this.piccnew.timeend))
        var url = "/uploadExcel_bcgs";
        this.$http.post(url, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
            .then((res) => {
              const loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              if (res.data.code == '1') {

                this.redisPageList();
                this.$message.success(res.data.msg);
                this.$message({
                  showClose: true,
                  duration: 5000,
                  type: 'success',
                  message: res.data.msg
                });
                // this.errorlist = res.data.errorlist;
                this.showfilelist = true;
                this.alert_success = '上传成功' + res.data.totals + '条';
                this.alert_error = '上传失败' + 0 + '条';
                console.log(res);
                this.deleteshow = true;

              }
              if (res.data.code == '-3') {

                this.$message({
                  showClose: true,
                  duration: 8000,
                  type: 'error',
                  message: res.data.msg
                });
                this.redisPageList();
                this.alert_success = '上传成功' + 0 + '条';
                this.alert_error = '上传错误' + res.data.errorlist.length + '条';
                console.log(res);
                this.deleteshow = true;
                loading.close();
              }
              if (res.data.code == '-2') {

                this.$message({
                  showClose: true,
                  duration: 8000,
                  type: 'error',
                  message: res.data.msg
                });
                this.errorlist = res.data.errorlist;
                this.showfilelist = true;
                this.alert_success = '上传成功' + 0 + '条';
                this.alert_error = '上传重复' + res.data.errorlist.length + '条';
                console.log(res);
                this.deleteshow = true;
              }
              if (res.data.code == '-1') {

                this.$message({
                  showClose: true,
                  duration: 8000,
                  type: 'error',
                  message: res.data.msg
                });
                this.errorlist = res.data.errorlist;
                this.redisPagelist = [];
              }
              if (res.data.code == '-4') {

                this.$message({
                  showClose: true,
                  duration: 8000,
                  type: 'error',
                  message: res.data.msg
                });
                this.errorlist = res.data.ybllist;
                this.showfilelist = true;
                this.alert_success = '上传成功' + 0 + '条';
                if(res.data.ybllist){
                  this.alert_error = '上传人员已办理业务人数' + res.data.ybllist.length + '条';
                }
                console.log(res);
                this.deleteshow = true;
                this.fullscreenLoading = false;
              }
              loading.close();
            }).catch((err) => {
              this.$message({
                showClose: true,
                duration: 8000,
                type: 'error',
                message: '上传失败！！！'
              });
              // loading.close();
          })
      } else {

        this.$message({
          showClose: true,
          duration: 8000,
          type: 'error',
          message: '上传失败！！！，请选择正确的xlsx模板文件'
        });
        loading.close();
      }
      this.$refs.file.value = null;
    },
    //获取表格序号
    getIndex($index) {
      //表格序号
      return (this.queryInfo.pageNum - 1) * this.queryInfo.pageSize + $index + 1
    },
    // 删除按钮
    async deleteRedisPageList(num) {
      // 弹框
      const confirmResult = await this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      // 成功删除为confirm 取消为 cancel
      if (confirmResult != 'confirm') {
        return this.$message.info("已取消删除");
      }
      const {
        data: res
      } = await this.$http.get("deletRedisPageList?num=" + num + "&aab001=2_" + this.user.aab001);
      if (res != "success") {
        return this.$message.error("操作失败！！！");
      }
      this.$message.success("操作成功！！！");
      this.redisPageList();
    },
    // 清空按钮
    async deleteFile(aab001) {
      // 弹框
      const confirmResult = await this.$confirm('清空人员名单, 是否继续?', '提示', {
        async: false,
        cache: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      // 成功删除为confirm 取消为 cancel
      if (confirmResult != 'confirm') {
        return this.$message.info("已取消删除");
      }

      const {
        data: res
      } = await this.$http.get("deleteFile?aab001=2_" + aab001);
      if (res != "success") {
        return this.$message.error("操作失败！！！");
      }
      this.errorlist=[];
      this.redisPagelist =[]
      this.$message.success("操作成功！！！");
      this.showfilelist = false;
      this.redisPageList();
    },
    //确定提交数据
    async insertfile() {
      if (this.piccnew.timeaction == '' && this.piccnew.timeend == '') {
        this.$message({
          duration: 600,
          type: 'error',
          message: '请选择时间段！！！'
        });
        return;
      }
      if (this.total != this.piccnew.num) {
        return this.$message.error("操作失败，上传人员数量与参保人数不一致，请核对信息！");
      }
      // 弹框
      const confirmResult = await this.$confirm('补充工伤保险-[补缴申报]，参保人数为 [' + this.piccnew.num + '] 人，保费金额为 [' + this.piccnew.spacec + '] 元。请确认以上信息，并进入下一步。"', '提示', {
        async: false,
        cache: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      // 成功删除为confirm 取消为 cancel
      if (confirmResult != 'confirm') {
        return this.$message.info("已取消提交");
      }
      let moment = require('moment');
      this.piccnew.userstatus = '2';
      this.piccnew.spaceb = moment().format("YYYY-MM-DD HH:mm:ss");
      const {
        data: res
      } = await this.$http.post("addpiccnew_bcgs", this.piccnew, {

      });
      console.log(res)
      if (res.state != "200") {
        return this.$message.error(res.msg);
      }
      window.sessionStorage.setItem('activePath', "/sljl");
      this.$router.push("/sljl");
      this.reload();
      // this.$message.success("操作成功！！！");

    },
    //返回填写基本信息
    txjbxx() {

      this.steponeShow = true;
      this.steptwoShow = false;
      this.errorlist=[];
      this.redisPagelist =[]
      this.$http.get("deleteFile?aab001=1_" + this.user.aab001);

    },
    //输入人员数量时计算应缴钱数
    getspacee(num) {
      //每个月的钱
      // this.piccnew.spacec = num * 8;
      //总钱
      this.piccnew.spacec = num * this.user.column2 * this.monthnum;
    },
    //判断是否办理
    async sfbl() {

      let moment = require('moment');
      var formData = new FormData()
      formData.append('aab001', this.user.aab001);
      formData.append('timeaction', '' + moment().startOf('month').subtract('month', -1).format("YYYY-MM-DD"));
      formData.append('timeend', '' + moment().endOf('month').subtract('month', -1).endOf('month').format("YYYY-MM-DD"));
      // 调用post请求
      const {
        data: res
      } = await this.$http.post("sfbl", formData, {}, { });
      if (res > 0) {
        if (this.$route.params.id == null) {
          this.steponeShow = false;
          this.steptwoShow = false;
          this.yjblShow = true;
        } else {
          this.piccnew.spacea = this.$route.params.id;
          this.steponeShow = true;
          this.yjblShow = false;
        }

      } else {
        this.steponeShow = true;
        this.yjblShow = false;
        this.piccnew.spacea = this.$route.params.id;
      }
      this.steponeShow = true;
      this.yjblShow = false;
    },
    //获取选中数据
    getTemplateRow(index, row) {
      this.updateuser.usertype = '0' + (index + 1);
      this.updateuser.column1 = row.hylb + '  ' + row.fy;

    },
    //确定选择行业类别
    gethylb() {

      this.innerVisible = false;
    },
    //提交单位信息维护
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        console.log(valid);
        if (!valid) return;
        // 发起请求
        let moment = require('moment');
        this.updateuser.rqtime = moment().format("YYYY-MM-DD HH:mm:ss");
        const {
          data: res
        } = await this.$http.post("updatePiccuser", this.updateuser);
        if (res.result != "success") {
          return this.$message.error("操作失败！！！");
        }
        this.$message.success("单位信息维护修改成功！！！");

        // window.sessionStorage.setItem("user", JSON.stringify(res.user)); // session 放置
        this.resetSetItem('user', JSON.stringify(res.user));
        //隐藏
        this.dialogFormVisible = false;
      })
    },
    getdateValue(val) {

      let moment = require('moment');
      this.piccnew.timeaction = moment(this.startTime[0]).startOf('month').format("YYYY-MM-DD");
      this.piccnew.timeend = moment(this.startTime[1]).endOf('month').format("YYYY-MM-DD");
      // let yearnum = this.startTime[1].getFullYear() - this.startTime[0].getFullYear() - 0;
      // if (parseInt(yearnum) == 0) {
      //     this.monthnum = this.startTime[1].getMonth() - this.startTime[0].getMonth() + 1;
      // } else {
      //     this.monthnum = parseInt((yearnum * 12) + (this.startTime[1].getMonth() - this.startTime[0].getMonth() + 1));
      // }
      let date1 = this.piccnew.timeend.split('-'); //例：将2020-12-21 的-去掉
      date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]); //将字符串转换为数字格式
      let date2 = this.piccnew.timeaction.split('-');
      date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
      this.monthnum = date1 - date2 +1;
      this.getspacee(this.piccnew.num);

    },
    //下载人员名单模板
    downloadMb() {
      const link = document.createElement('a')
      // download属性
      link.setAttribute('download', "人员名单模板.xls")
      // href链接
      link.setAttribute('href', "/file/%E4%BA%BA%E5%91%98%E5%90%8D%E5%8D%95%E6%A8%A1%E6%9D%BF.xls")

      // 自执行点击事件
      link.click()

    },
    //判断当前月是否办理
    async dqsfbl() {

      let moment = require('moment');
      var formData = new FormData()
      formData.append('aab001', this.user.aab001);
      formData.append('timeaction', '' + moment().startOf('month').format("YYYY-MM-DD"));
      formData.append('timeend', '' + moment().endOf('month').format("YYYY-MM-DD"));
      // 调用post请求
      const {
        data: res
      } = await this.$http.post("sfbl", formData, {}, {

      });
      // if (res.sfblCount == 0) {
      //     this.messages = '不可办理:无本月办理记录!请点击受理记录查看';
      //     this.cardshow = true;
      // } else {
      this.steponeShow = true;
      // this.piccnew = res.sfbl;
      this.piccnew.term = '2';
      // this.piccnew.timeaction = '';
      // this.piccnew.timeend = '';
      this.piccnew.spacea = '';
      this.piccnew.userstatus = '0';
      if (this.$route.params.id != null) {
        this.piccnew.spacea = this.$route.params.id;
      }
      // }
    },
    //返回首页
    gohome() {
      window.sessionStorage.setItem('activePath', "/welcome");
      this.$router.push("/welcome");
      this.reload();
    },
  },
  // watch: {
  //   "piccnew.num": {
  //     deep: true,
  //     handler(val) {
  //       console.log(val);
  //       console.log(val);
  //       console.log(val);
  //     }
  //   }
  // },
};
</script>
<style lang="less" scoped>
#card_st {
  width: 80%;
  margin: auto;
}

.text {
  font-size: 16px;
  width: 100%;
  padding-left: 100px;
}

.item {
  margin-bottom: 24px;
}

.el-alert {
  margin-top: 10px;
}

/deep/.el-radio__label {
  font-size: 14px;
  padding-left: 10px;
  display: none;
}
</style>

<style>
//修改table一列内容超出显示宽度
.el-tooltip__popper {
  max-width: 50%;
}

.el-tooltip__popper,
.el-tooltip__popper.is-dark {
  background: rgb(48, 65, 86) !important;
  color: #fff !important;
  line-height: 24px;
}
</style>
